import * as ActionTypes from '../constants/ActionTypes'
import { getRequest, postRequest } from './http'

export function loading() {
  return {
    type: ActionTypes.LOADING_CHANGE
  }
}

export function setData(items, name) {
  return {
    type: ActionTypes.DATA,
    name: name,
    items: items
  }
}

export function changeFields(fields){
  return {
    type: ActionTypes.SET_FIELDS,
    fields: fields
  }
}

export function data_with_pagination(items, name) {
  return {
    type: ActionTypes.DATA_WITH_PAGINATION,
    name: name,
    items: items
  }
}

export function errorForm(errors){
  return{
    type: ActionTypes.SET_ERROR_FORMS,
    errors: errors
  }
}

const getChild = (data, typeOption) => {
  data.typeOption = typeOption;
  return (dispatch) => {
    dispatch(loading());
    getRequest(data, "progress").then(
      (response) => {
        dispatch(setData(response.data.user, 'user'));
        dispatch(data_with_pagination(response.data.evidencias, 'eva'));
        dispatch(setData(response.data.docentes, 'doc'));
        dispatch(setData(response.data.headerb, 'headerb'));
        dispatch(setData(response.data.headers, 'headers'));
        dispatch(setData(response.data.notasbimensuales, 'nb'));
        dispatch(setData(response.data.notasevidencias, 'ne'));
        dispatch(setData(response.data.pays, 'pays'));
        dispatch(loading());
      },
      (err) => {
        dispatch(loading());
        if (err.response.status === 401) {
          dispatch(setData(true, 'error401'));
        }else{
          dispatch(setData(true, 'error'));
        }
      }
    );
  }
};

const sendMessages = (data, typeOption) => {
  data.typeOption = typeOption;
  return (dispatch) => {
    dispatch(loading());
    dispatch(errorForm({'errors':{}}));
    postRequest(data, "messages").then(
    (response) => {
      data.message = "";
      data.subject = "";
      dispatch(changeFields(data));
      dispatch(setData('Mensaje enviado correctamente', 'toastMessage'));
      dispatch(setData(true, 'simpleToast'));
      setTimeout(function(){
        dispatch(setData(false, 'simpleToast'));
      }, 3000);
      dispatch(loading());
    },
    (err) => {
      dispatch(loading());
      if (err.response.status === 401) {
        dispatch(setData(true, 'error401'));
      }else if(err.response.status === 422){
        dispatch(errorForm(err.response.data));
      }else{
        dispatch(setData(true, 'error'));
      }
    }
    );
  }
};

export default {
  getChild,
  changeFields,
  sendMessages,
  errorForm
}
